import StorageService from '../services/storage.service';
import { commonAction, authType, bankTransfer } from './type';
import AuthService from '../services/auth.service';
import { pendingBankTransfer } from './bankTransfer';
// Actions - Login

export const login = (_authUser) => async (dispatch) => {
  try {
    StorageService.setObject('authUser', _authUser);
    dispatch({
      type: authType.SUCCESS,
      payload: {
        user: _authUser,
      },
    });
    dispatch(pendingBankTransfer());
  } catch (error) {
    dispatch({
      type: authType.FAILURE,
    });
    return Promise.reject(error);
  }
};

export const logout = () => (dispatch) => {
  try {
    StorageService.purgeData('authUser');
    StorageService.purgeData('bankTransfer');

    dispatch({ type: authType.LOGOUT });
    dispatch({ type: bankTransfer.CLEAR_BANK_TRANSFER });
  } catch {
    dispatch({ type: authType.FAILURE });
  }

  if (window.$chatwoot) {
    window.$chatwoot.reset();
  }
};

export const updateAuthUser = (_formData) => async (dispatch) => {
  try {
    StorageService.setObject('authUser', _formData);

    dispatch({
      type: authType.SUCCESS,
      payload: { user: _formData },
    });
  } catch (error) {
    dispatch({
      type: authType.FAILURE,
    });
    return Promise.reject(error);
  }
};

export const verifyTwoFA = (verifyTwoFAData) => async (dispatch) => {
  try {
    const response = await AuthService.verifyTwoFA(verifyTwoFAData);
    if (response.status === 'failure') {
      dispatch({
        type: commonAction.FAILURE,
      });
    }

    dispatch({
      type: commonAction.SUCCESS,
      payload: '',
    });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: commonAction.FAILURE,
    });
    return Promise.reject(error);
  }
};
